import React from 'react';

const Pro = () => {
    return (
       <div>
           <h3>Make Card for pricing and access of pro version</h3>
       </div>
    )
}

export default Pro;